export function regexp({ el, directive, component, cleanup }) {
    // The "directive" object gives you access to the parsed directive.
    // For example, here are its values for: wire:click.prevent="deletePost(1)"
    //
    // directive.raw = wire:click.prevent
    // directive.value = "click"
    // directive.modifiers = ['prevent']
    // directive.expression = "deletePost(1)"

    let reg_exp = new RegExp(directive.expression);

    // Clear any existing error message

    let onBlur = (e) => {
        e.preventDefault();
        if (e.detail && e.detail.isCustom) return;

        const errorMessage = "Input does not match the required format.";
        const errorSpanId = "error-message" + el.name;

        const existingError = document.getElementById(errorSpanId);
        if (existingError) {
            existingError.remove();
        }

        let modifier = directive.modifiers[1];
        let reg_exp = new RegExp(directive.expression);
        if (["i", "g", "m", "d"].includes(modifier)) {
            reg_exp = new RegExp(directive.expression, modifier);
        } else {
            reg_exp = new RegExp(directive.expression);
        }
        if (!reg_exp.test(el.value)) {
            const errorSpan = document.createElement("span");
            errorSpan.id = errorSpanId; // Give it an ID for future reference
            errorSpan.textContent = errorMessage;
            errorSpan.classList.add("text-sm", "text-rose-600");
            errorSpan.style.color = "red"; // Optional: style the error message
            const label = el.closest("label");

            if (label) {
                label.parentNode.insertBefore(errorSpan, label.nextSibling);
            } else {
                // Append the error message below the input element
                el.parentNode.insertBefore(errorSpan, el.nextSibling);
            }
        }
    };

    //
    let onFormatInput = (e) => {
        const cursorPosition = el.selectionStart; // Get the current cursor position
        const currentValue = el.value; // Store the previous value

        let modifier = directive.modifiers[1];
        let reg_exp = null;
        if (["i", "g", "m", "d"].includes(modifier)) {
            reg_exp = new RegExp(directive.expression, modifier);
        } else {
            reg_exp = new RegExp(directive.expression);
        }

        if (!reg_exp.test(currentValue)) {
            let val =
                currentValue.slice(0, cursorPosition - 1) +
                currentValue.slice(cursorPosition); // Remove the last character before cursor

            el.value = val;
            el.setSelectionRange(cursorPosition - 1, cursorPosition - 1); // Move the cursor position back
        }
    };

    // Stop other listeners of the same event from being called
    let onFormatPaste = (e) => {
        e.preventDefault(); // Prevent the default action
        e.stopImmediatePropagation();
    };

    //RESTRICTS THE CHARACTERS TO given regexp characters
    let onRestrictInput = (e) => {
        e.preventDefault();
        if (e.detail && e.detail.isCustom) return;
        const previousValue = el.value; // Store the previous value
        const newData = el.data; // Get the new input data

        let modifier = directive.modifiers[1];
        let reg_exp = null;

        if (["i", "g", "m", "d"].includes(modifier)) {
            reg_exp = new RegExp(directive.expression, modifier);
        } else {
            reg_exp = new RegExp(directive.expression);
        }

        // Check for matches in the new data
        if (reg_exp.test(newData)) {
            // Replace matched characters with an empty string
            const cleanedValue = previousValue
                .split("")
                .filter((char) => reg_exp.test(char))
                .join("");

            // Set the cleaned value back to the input element
            el.value = cleanedValue;
        }
    };

    if (directive.modifiers.includes("check")) {
        el.addEventListener("blur", onBlur, { capture: true });
    }
    if (directive.modifiers.includes("format")) {
        el.addEventListener("input", onFormatInput, { capture: true });
        el.addEventListener("paste", onFormatPaste, { capture: true }); // disabled pasting of any content on format field
    }
    if (directive.modifiers.includes("restrict")) {
        el.addEventListener("input", onRestrictInput, { capture: true });
    }

    // Register any cleanup code inside `cleanup()` in the case
    // where a Livewire component is removed from the DOM while
    // the page is still active.
    cleanup(() => {
        el.removeEventListener("click", onRestrictInput);
        el.removeEventListener("click", onFormatInput);
        el.removeEventListener("click", onFormatPaste);
        el.removeEventListener("blur", onBlur);
    });
}
